import { Shield, Eye, Server, FileText, QrCode, ShieldCheck } from 'lucide-react'

export function FeaturesSection() {
  const features = [
    {
      icon: <Shield className="w-8 h-8 sm:w-10 sm:h-10 text-primary" />,
      title: 'Client-Side Encryption',
      description: 'All encryption happens in your browser using the Web Crypto API. Your plaintext never reaches our servers.'
    },
    {
      icon: <Eye className="w-8 h-8 sm:w-10 sm:h-10 text-primary" />,
      title: 'Burn-After-Read',
      description: 'Secrets are permanently deleted after viewing. Atomic database operations ensure no recovery is possible.'
    },
    {
      icon: <Server className="w-8 h-8 sm:w-10 sm:h-10 text-primary" />,
      title: 'Zero-Knowledge',
      description: 'We never see your encryption keys or plaintext data. Even we cannot decrypt your secrets.'
    },
    {
      icon: <FileText className="w-8 h-8 sm:w-10 sm:h-10 text-primary" />,
      title: 'Secret Templates',
      description: 'Pre-formatted templates for API keys, database credentials, SSH keys, and more. Never forget important details.'
    },
    {
      icon: <QrCode className="w-8 h-8 sm:w-10 sm:h-10 text-primary" />,
      title: 'QR Code Sharing',
      description: 'Generate QR codes for instant mobile sharing. Perfect for quickly transferring secrets between devices.'
    },
    {
      icon: <ShieldCheck className="w-8 h-8 sm:w-10 sm:h-10 text-primary" />,
      title: 'Password Strength Meter',
      description: 'Real-time passphrase analysis with helpful suggestions. Ensure your secrets are protected with strong passphrases.'
    }
  ]

  return (
    <div className="mt-12 sm:mt-16 mb-12 sm:mb-16">
      <h2 className="text-2xl sm:text-3xl font-mono font-semibold text-center text-foreground mb-8 sm:mb-12">
        Why SafeMonk?
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
        {features.map((feature, i) => (
          <div key={i} className="bg-card border border-border rounded-card p-6 sm:p-8 text-center">
            <div className="flex justify-center mb-4">
              {feature.icon}
            </div>
            <h3 className="text-lg sm:text-xl font-semibold text-foreground mb-3">
              {feature.title}
            </h3>
            <p className="text-sm sm:text-base text-muted-foreground">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}